import { ChallengeQuery } from '../Challenge/ChallengeQuery';
import { SessionQuery } from '../SessionQuery';

export interface PracticePlanFilters {
  tag?: string[];
  duration?: string[];
  difficulty?: string[];
  coach?: string[];
  phrase?: string[];
  liked?: boolean;
}

export interface PracticePlanQuery {
  title?: undefined;
  underline?: undefined;
  page?: number;
  limit?: number;
  filters?: PracticePlanFilters;
}

export class PracticePlanQuery {
  static serializeToUrlParams(query: PracticePlanQuery): string {
    return SessionQuery.serializeToUrlParams(query as ChallengeQuery);
  }

  static deserializeFromUrlParams(paramString: string): PracticePlanQuery {
    return SessionQuery.deserializeFromUrlParams(paramString, true) as PracticePlanQuery;
  }
}
